import React, { useState, useEffect } from 'react'
import { DataTable, TextInput, Button } from '@paypalcorp/pp-react'
import Fuse from 'fuse.js'

const CountryCell = ({ value }: { value: string }) => {
  if (value.indexOf('(') > -1) {
    const sendOnlyParts = value.split('(')
    return (
      <span>
        {sendOnlyParts[0]}
        <br />
        {`(${sendOnlyParts[1]}`}
      </span>
    )
  }

  return value
}

const allRows = [
  {
    id: 'row1',
    country: { value: 'Albania' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row2',
    country: { value: 'Algeria' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row3',
    country: { value: 'Andorra' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row4',
    country: { value: 'Angola(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row5',
    country: { value: 'Anguilla(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row6',
    country: { value: 'Antigua & Barbuda' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row7',
    country: { value: 'Argentina' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row8',
    country: { value: 'Armenia(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row9',
    country: { value: 'Aruba(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row10',
    country: { value: 'Australia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row11',
    country: { value: 'Austria' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row12',
    country: { value: 'Azerbaijan(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row13',
    country: { value: 'Bahamas' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row14',
    country: { value: 'Bahrain' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row15',
    country: { value: 'Barbados' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row16',
    country: { value: 'Belarus(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row17',
    country: { value: 'Belgium' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row18',
    country: { value: 'Belize' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row19',
    country: { value: 'Benin(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row20',
    country: { value: 'Bermuda' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row21',
    country: { value: 'Bhutan(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row22',
    country: { value: 'Bolivia(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row23',
    country: { value: 'Bosnia & Herzegovina' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row24',
    country: { value: 'Botswana' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row25',
    country: { value: 'Brazil' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row26',
    country: { value: 'British Virgin Islands(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row27',
    country: { value: 'Brunei(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row28',
    country: { value: 'Bulgaria' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row29',
    country: { value: 'Burkina Faso(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row30',
    country: { value: 'Burundi(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row31',
    country: { value: "Cote d'Ivoire(Send only)" },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row32',
    country: { value: 'Cambodia(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row33',
    country: { value: 'Cameroon(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row34',
    country: { value: 'Canada' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row35',
    country: { value: 'Cape Verde(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row36',
    country: { value: 'Cayman Islands' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row37',
    country: { value: 'Chad(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row38',
    country: { value: 'Chile' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row39',
    country: { value: 'China' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row40',
    country: { value: 'Colombia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row41',
    country: { value: 'Comoros(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row42',
    country: { value: 'Congo-Brazzaville(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row43',
    country: { value: 'Cook Islands(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row44',
    country: { value: 'Costa Rica' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row45',
    country: { value: 'Croatia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row46',
    country: { value: 'Cyprus' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row47',
    country: { value: 'Czech Republic' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row48',
    country: { value: 'Denmark' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row49',
    country: { value: 'Djibouti(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row50',
    country: { value: 'Dominica' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row51',
    country: { value: 'Dominican Republic' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row52',
    country: { value: 'Ecuador' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row53',
    country: { value: 'Egypt' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row54',
    country: { value: 'El Salvador' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row55',
    country: { value: 'Eritrea(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row56',
    country: { value: 'Estonia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row57',
    country: { value: 'Ethiopia(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row58',
    country: { value: 'Falkland Islands(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row59',
    country: { value: 'Faroe Islands' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row60',
    country: { value: 'Finland' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row61',
    country: { value: 'Fiji' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row62',
    country: { value: 'France' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row63',
    country: { value: 'French Guiana' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row64',
    country: { value: 'French Polynesia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row65',
    country: { value: 'Gabon(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row66',
    country: { value: 'Gambia(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row67',
    country: { value: 'Georgia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row68',
    country: { value: 'Germany' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row69',
    country: { value: 'Gibraltar' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row70',
    country: { value: 'Greece' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row71',
    country: { value: 'Greenland' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row72',
    country: { value: 'Grenada' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row73',
    country: { value: 'Guadeloupe' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row74',
    country: { value: 'Guatemala' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row75',
    country: { value: 'Guinea(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row76',
    country: { value: 'Guinea-Bissau(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row77',
    country: { value: 'Guyana(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row78',
    country: { value: 'Honduras' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row79',
    country: { value: 'Hong Kong SAR China' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row80',
    country: { value: 'Hungary' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row81',
    country: { value: 'Iceland' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row82',
    country: { value: 'India' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row83',
    country: { value: 'Indonesia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row84',
    country: { value: 'Ireland' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row85',
    country: { value: 'Italy' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row86',
    country: { value: 'Jamaica' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row87',
    country: { value: 'Japan' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row88',
    country: { value: 'Jordan' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row89',
    country: { value: 'Kazakhstan' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row90',
    country: { value: 'Kenya' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row91',
    country: { value: 'Kiribati(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row92',
    country: { value: 'Kuwait' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row93',
    country: { value: 'Kyrgyzstan(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row94',
    country: { value: 'Laos(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row95',
    country: { value: 'Latvia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row96',
    country: { value: 'Lesotho' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row97',
    country: { value: 'Liechtenstein' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row98',
    country: { value: 'Lithunia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row99',
    country: { value: 'Luxembourg' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row100',
    country: { value: 'Macedonia(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row101',
    country: { value: 'Madagascar(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row102',
    country: { value: 'Malawi' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row103',
    country: { value: 'Malaysia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row104',
    country: { value: 'Maldives(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row105',
    country: { value: 'Mali(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row106',
    country: { value: 'Malta' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row107',
    country: { value: 'Marshall Islands(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row108',
    country: { value: 'Martinique' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row109',
    country: { value: 'Mauritania(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row110',
    country: { value: 'Mauritius' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row111',
    country: { value: 'Mayotte(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row112',
    country: { value: 'Mexico' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row113',
    country: { value: 'Micronesia(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row114',
    country: { value: 'Moldova' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row115',
    country: { value: 'Monaco' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row116',
    country: { value: 'Mongolia(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row117',
    country: { value: 'Montenegro(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row118',
    country: { value: 'Montserrat(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row119',
    country: { value: 'Morocco' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row120',
    country: { value: 'Mozambique' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row121',
    country: { value: 'Namibia(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row122',
    country: { value: 'Nauru(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row123',
    country: { value: 'Nepal(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row124',
    country: { value: 'Netherlands' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row125',
    country: { value: 'New Caledonia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row126',
    country: { value: 'New Zealand' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row127',
    country: { value: 'Nicaragua' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row128',
    country: { value: 'Niger(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row129',
    country: { value: 'Nigeria(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row130',
    country: { value: 'Niue(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row131',
    country: { value: 'Norfolk Island(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row132',
    country: { value: 'Norway' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row133',
    country: { value: 'Oman' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row134',
    country: { value: 'Palau' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row135',
    country: { value: 'Panama' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row136',
    country: { value: 'Papua New Guinea(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row137',
    country: { value: 'Paraguay(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row138',
    country: { value: 'Peru' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row139',
    country: { value: 'Philippines' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row140',
    country: { value: 'Pitcairn Islands(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row141',
    country: { value: 'Poland' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row142',
    country: { value: 'Portugal' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row143',
    country: { value: 'Qatar' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row144',
    country: { value: 'Reunion' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row145',
    country: { value: 'Romania' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row146',
    country: { value: 'Russia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row147',
    country: { value: 'Rwanda(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row148',
    country: { value: 'Sao Tome & Principe(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row149',
    country: { value: 'Samoa(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row150',
    country: { value: 'San Marino' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row151',
    country: { value: 'Saudi Arabia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row152',
    country: { value: 'Senegal' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row153',
    country: { value: 'Serbia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row154',
    country: { value: 'Seychelles' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row155',
    country: { value: 'Sierra Leone(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row156',
    country: { value: 'Singapore' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row157',
    country: { value: 'Slovakia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row158',
    country: { value: 'Slovenia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row159',
    country: { value: 'Solomon Islands(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row160',
    country: { value: 'Somalia(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row161',
    country: { value: 'South Africa' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row162',
    country: { value: 'South Korea' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row163',
    country: { value: 'Spain' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row164',
    country: { value: 'St. Helena(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row165',
    country: { value: 'St. Kitts & Nevis' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row166',
    country: { value: 'St. Lucia' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row167',
    country: { value: 'St. Pierre & Miquelon(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row168',
    country: { value: 'St. Vincent & Grenadines(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row169',
    country: { value: 'Suriname(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row170',
    country: { value: 'Svalbard & Jan Mayen(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row171',
    country: { value: 'Swaziland' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row172',
    country: { value: 'Sweden' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row173',
    country: { value: 'Switzerland' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row174',
    country: { value: 'Taiwan' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row175',
    country: { value: 'Tajikistan(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row176',
    country: { value: 'Tanzania(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row177',
    country: { value: 'Thailand' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row178',
    country: { value: 'Togo(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row179',
    country: { value: 'Tonga(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row180',
    country: { value: 'Trinidad & Tobago' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row181',
    country: { value: 'Tunisia(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row182',
    country: { value: 'Turkmenistan(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row183',
    country: { value: 'Turks & Caicos Islands' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row184',
    country: { value: 'Tuvalu(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row185',
    country: { value: 'Uganda(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row186',
    country: { value: 'Ukraine(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row187',
    country: { value: 'United Arab Emirates' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row188',
    country: { value: 'United Kingdom' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row189',
    country: { value: 'United States' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'Yes' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row190',
    country: { value: 'Uruguay' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row191',
    country: { value: 'Vatican City(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row192',
    country: { value: 'Venezuela' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row193',
    country: { value: 'Vietnam' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'Yes' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row194',
    country: { value: 'Wallis & Futuna(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row195',
    country: { value: 'Yemen(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row196',
    country: { value: 'Zambia(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
  {
    id: 'row197',
    country: { value: 'Zimbabwe(Send only)' },
    bbs: { value: 'Yes' },
    bas: { value: 'Yes' },
    cbs: { value: 'No' },
    cas: { value: 'No' },
    bba: { value: 'No' },
    cba: { value: 'No' },
    baa: { value: 'No' },
    caa: { value: 'No' },
  },
]

const columns = {
  country: {
    title: <span>Country</span>,
    cellAs: CountryCell,
    width: '15%',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  bbs: {
    title: (
      <span>
        Business,
        <br />
        before,
        <br />
        standard
      </span>
    ),
    mobile: {
      placement: 'b3',
    },
  },
  bas: {
    title: (
      <span>
        Business,
        <br />
        after,
        <br />
        standard
      </span>
    ),
    mobile: {
      placement: 'b3',
    },
  },
  cbs: {
    title: (
      <span>
        Casual,
        <br />
        before,
        <br />
        standard
      </span>
    ),
    mobile: {
      placement: 'b3',
    },
  },
  cas: {
    title: (
      <span>
        Casual,
        <br />
        after,
        <br />
        standard
      </span>
    ),
    mobile: {
      placement: 'b3',
    },
  },
  bba: {
    title: (
      <span>
        Business,
        <br />
        before,
        <br />
        advanced
      </span>
    ),
    mobile: {
      placement: 'b3',
    },
  },
  cba: {
    title: (
      <span>
        Casual,
        <br />
        before,
        <br />
        advanced
      </span>
    ),
    mobile: {
      placement: 'b3',
    },
  },
  baa: {
    title: (
      <span>
        Business,
        <br />
        after,
        <br />
        advanced
      </span>
    ),
    mobile: {
      placement: 'b3',
    },
  },
  caa: {
    title: (
      <span>
        Casual,
        <br />
        after,
        <br />
        advanced
      </span>
    ),
    mobile: {
      placement: 'b3',
    },
  },
}

const options = {
  threshold: 0.2,
  keys: ['country.value'],
}

const fuse = new Fuse(allRows, options)

const CountryEligibility = () => {
  const [rows, setRows] = useState(allRows.slice(0, 5))
  const [isLoading, setLoading] = useState(false)
  const [searchInput, setSearchInput] = useState('')
  const [filteredRows, setFilteredRows] = useState([])
  const showSeeMoreBtn = rows.length < allRows.length

  useEffect(() => {
    if (searchInput) {
      const searchResult = fuse.search(searchInput)
      setFilteredRows(searchResult.map((items) => items.item))
    } else {
      setFilteredRows([])
    }
  }, [searchInput])

  const handleTextChange = (e) => {
    setSearchInput(e.target.value)
  }

  const handleSeeMore = () => {
    setSearchInput('')
    setLoading(true)
    setTimeout(() => {
      setRows((currRowsShown) => allRows.slice(0, currRowsShown.length + 5))
      setLoading(false)
    }, 300)
  }

  return (
    <>
      <TextInput
        name="basic"
        value={searchInput}
        label="Search table"
        labelClassName="test"
        onKeyUp={handleTextChange}
      />
      <DataTable
        description="Basic"
        rows={searchInput ? filteredRows : rows}
        columns={columns}
        isLoading={isLoading}
        idPrefix="basic"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
      {showSeeMoreBtn && (
        <div className="table-btnWrapper">
          <Button onClick={handleSeeMore} size="sm" secondary>
            See more
          </Button>
        </div>
      )}
    </>
  )
}

export default CountryEligibility
